export enum EnumNetwork {
  MainNet,
  TestNet,
}